import { apiClient } from "../config";

async function editSurvey(id: string, data: any) {
  const res = await apiClient.put(`/admin/survey-and-polls/${id}`, data);
  return res.data;
}

export default editSurvey;
